module.exports = __webpack_public_path__ + "img/13.b09ee92c.png";